import React, {Component} from 'react';
import {Row, Col, Tabs, Tab, ControlLabel, FormControl, Form, FormGroup} from "react-bootstrap";
import {TopButtonSave} from "../../../../componentsTopsa/buttons/TopButtons";
import {TopAlertSukces, TopAlertUwaga} from "../../../../componentsTopsa/alerty/TopAlerts";
import TopIf from "../../../../componentsTopsa/if/TopIf";
import UzytkownicyService from "../../../administracja/dostep/DostepService";
import LogowanieService from "../../../logowanie/LogowanieService";
import ValidatorMessages from "../../../../shared/validatorMessages/ValidatorMessages";


export default class ZmianaHaslaForm extends Component {
    constructor(props) {
        super(props);
        this.state = {
            starehaslo: '',
            nowehaslo: '',
            powtorznowehaslo: '',
            pomyslnieZmieniono: false,
            focusNaHasle: false,
            validatorMessages: [],

        };
        this.onClickZapiszHaslo = this.onClickZapiszHaslo.bind(this)
        this.onChangeStareHaslo = this.onChangeStareHaslo.bind(this)
        this.onChangeNoweHaslo = this.onChangeNoweHaslo.bind(this)
        this.onChangePowtorzNoweHaslo = this.onChangePowtorzNoweHaslo.bind(this)
    }

    onChangeStareHaslo(e) {
        this.setState({starehaslo: e.target.value})
    }

    onChangeNoweHaslo(e) {
        if (e.target.value.length <= 20) {
            this.setState({nowehaslo: e.target.value})
        } else {
            document.getElementById('nowehasloInput').value = this.state.nowehaslo
        }
    }

    onChangePowtorzNoweHaslo(e) {
        if (e.target.value.length <= 20) {
            this.setState({powtorznowehaslo: e.target.value})
        } else {
            document.getElementById('powtorzhasloInput').value = this.state.powtorznowehaslo
        }
    }

    dodajDoValidatorMessages(msg) {
        let arr = this.state.validatorMessages;
        arr.push(msg)
        this.setState({validatorMessages: arr})
    }

    onClickZapiszHaslo() {
        this.setState({validatorMessages: [], pomyslnieZmieniono: false})
        let poprawne = true;
        this.state.validatorMessages = [];


        /*if (!Boolean(LogowanieService.pobierzZalogowanego().token == ('Basic ' + btoa(this.props.zalogowany.username + ':' + this.state.starehaslo)))) {
            poprawne = false;
            this.dodajDoValidatorMessages('Stare hasło jest niepoprawne')
        }*/
        if (!Boolean(this.state.nowehaslo.length > 0 && this.state.starehaslo.length > 0)) {
            poprawne = false;
            this.dodajDoValidatorMessages('Proszę uzupełnić wszystkie pola')
        }
        if (this.state.nowehaslo.length < 8 || this.state.nowehaslo.length > 20) {
            poprawne = false;
            this.dodajDoValidatorMessages('Hasło musi się zawierać w zakresie pomiędzy 8 - 20 znaków')
        }

        if (!this.czyZawieraCyfreLubZnakSpecjalny(this.state.nowehaslo) || !this.czyZawieraDuzaLitere(this.state.nowehaslo)) {
            poprawne = false;
            this.dodajDoValidatorMessages('Hasło musi zawierać przynajmniej jedną dużą literę oraz przynajmniej jedną cyfrę lub znak specjalny')
        }

        if (this.state.nowehaslo !== this.state.powtorznowehaslo) {
            poprawne = false;
            this.dodajDoValidatorMessages('Powtórzone hasło nie jest identyczne')
        }

        if (poprawne) {
            this.state.validatorMessages = [];
            this.setState({czyBylPrzycisk: false, validatorMessages: []})


            let data = {
                "idUz": this.props.zalogowany.idUz,
                "newPassword": this.state.nowehaslo,
                "oldPassword": this.state.starehaslo
            }
            UzytkownicyService.zmienHaslo(data).then(function (response) {
                if (response.status < 300) {
                    this.setState({pomyslnieZmieniono: true, focusNaHasle: false})
                    let user = LogowanieService.pobierzZalogowanego();
                    user.token = 'Basic ' + btoa(this.props.zalogowany.login + ':' + this.state.nowehaslo)
                    localStorage.removeItem('obecnyUserMacelApp');
                    LogowanieService.zalogujUzytkownika(user, 'Basic ' + btoa(this.props.zalogowany.login + ':' + this.state.nowehaslo))
                }
            }.bind(this))
        }

    }

    czyZawieraDuzaLitere(string) {
        if (string.length == 0) return false
        let pattern = "QWERTYUIOPASDFGHJKLZXCVBNM";
        let zawiera = false;
        for (let i = 0; i < pattern.length; i++) {
            if (string.indexOf(pattern[i]) > -1) {
                zawiera = true;
            }
        }
        return zawiera
    }

    czyZawieraCyfreLubZnakSpecjalny(string) {
        if (string.length == 0) return false
        let pattern = "1234567890!@#$%^&*()-_=+[]{};:/?<>,.";
        let zawiera = false;
        for (let i = 0; i < pattern.length; i++) {
            if (string.indexOf(pattern[i]) > -1) {
                zawiera = true;
            }
        }
        return zawiera
    }


    render() {

        return (

            <fieldset style={{marginTop: '15px'}}>
                <div className={'fieldset-label'}>Zmień hasło</div>
                <Form inline={true}>
                    <FormGroup>
                        <Col xs={12}>
                            <ControlLabel style={{width: '100px'}}>Stare hasło: </ControlLabel>
                            <FormControl type={'password'} style={{margin: '0 10px'}} onChange={this.onChangeStareHaslo}/>
                        </Col>
                        <Col xs={12} style={{marginTop: '5px'}}>
                            <ControlLabel style={{width: '100px'}}>Nowe hasło:</ControlLabel>
                            <FormControl type={'password'} style={{margin: '0 10px'}} onChange={this.onChangeNoweHaslo} id={'nowehasloInput'}
                                         onClick={() => this.setState({focusNaHasle: true})}/>

                        </Col>
                        <Col xs={12} style={{marginTop: '5px'}}>
                            <ControlLabel style={{width: '100px'}}>Powtórz hasło:</ControlLabel>
                            <FormControl type={'password'} style={{margin: '0 10px'}} onChange={this.onChangePowtorzNoweHaslo}
                                         id={'powtorzhasloInput'}/>
                            <TopButtonSave onClick={this.onClickZapiszHaslo}/>
                        </Col>
                    </FormGroup>
                    <FormGroup>
                        <Col xs={12}>
                            <TopIf isTrue={this.state.focusNaHasle}>
                                <div id={'zmianaHaslaHelp'}>
                                    <div>
                                        <label>Ilość znaków w haśle zawiera się w
                                            8-20? </label> {Boolean(this.state.nowehaslo.length >= 8 && this.state.nowehaslo.length <= 20) ?
                                        <i className="fa fa-check-circle"></i> : <i className="fa fa-times-circle"></i>}
                                    </div>
                                    <div>
                                        <label>Czy hasło zawiera dużą literę? </label> {Boolean(this.czyZawieraDuzaLitere(this.state.nowehaslo)) ?
                                        <i className="fa fa-check-circle"></i> : <i className="fa fa-times-circle"></i>}
                                    </div>
                                    <div>
                                        <label>Czy hasło zawiera liczbę lub
                                            znak? </label> {Boolean(this.czyZawieraCyfreLubZnakSpecjalny(this.state.nowehaslo)) ?
                                        <i className="fa fa-check-circle"></i> : <i className="fa fa-times-circle"></i>}
                                    </div>
                                    <div>
                                        <label>Czy powtórzone hasło jest
                                            identyczne? </label> {(this.state.nowehaslo === this.state.powtorznowehaslo && this.state.nowehaslo !== '') ?
                                        <i className="fa fa-check-circle"></i> : <i className="fa fa-times-circle"></i>}
                                    </div>
                                </div>
                            </TopIf>
                        </Col>
                    </FormGroup>
                    <FormGroup>
                        <Col xs={12}>
                            <ValidatorMessages messages={this.state.validatorMessages}/>
                        </Col>
                        <Col xs={12}>
                            <TopIf isTrue={Boolean(this.state.pomyslnieZmieniono)}>
                                <TopAlertSukces text={'Pomyślnie zmieniono hasło'}/>
                            </TopIf>
                        </Col>
                    </FormGroup>
                </Form>
            </fieldset>
        );
    }
}




// WEBPACK FOOTER //
// ./src/modules/home/danekonta/components/ZmianaHaslaForm.js